import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../ui/button';
import { useAuth } from '@/contexts/AuthContext';

export const Header: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  const isAdminRoute = location.pathname.startsWith('/dashboard') || location.pathname === '/admin';

  if (isAdminRoute && isAuthenticated) {
    return null; // Dashboard page handles its own header
  }

  if (isAdminRoute) {
    return (
      <header className="border-b bg-card">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <Link to="/" className="text-2xl font-bold">
            Customer Service Portal
          </Link>
          <div className="text-lg font-semibold">Admin Login</div>
        </div>
      </header>
    );
  }

  return (
    <header className="border-b bg-card">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <Link to="/" className="text-2xl font-bold">
          Customer Service Portal
        </Link>
        <nav className="flex items-center space-x-4">
          {/* <Link to="/complaint">
            <Button variant="outline">File Complaint</Button>
          </Link> */}
          <Link to="/admin">
            <Button>Admin Login</Button>
          </Link>
        </nav>
      </div>
    </header>
  );
};